import { useRef } from "react";

// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

// Material Kit 2 PRO React components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";

// Material Kit 2 PRO React examples
import DefaultNavbar from "components/Navbars/DefaultNavbar";

// Routes
import routes from "routes";

// Images
import bgImage from "assets/images/main-3-bg.png";

// Link configs
import LINKS from "config/links";

function NavbarHeader() {
    const headerRef = useRef(null);

    return (
        <>
            <MKBox bgColor="white">
                <DefaultNavbar routes={routes} transparent light />
            </MKBox>
            <MKBox
                ref={headerRef}
                minHeight="75vh"
                width="100%"
                sx={{
                    backgroundImage: ({
                        functions: { linearGradient, rgba },
                        palette: { gradients },
                    }) =>
                        `${linearGradient(
                            rgba(gradients.dark.main, 0.6),
                            rgba(gradients.dark.state, 0.6)
                        )}, url(${bgImage})`,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    display: "grid",
                    placeItems: "center",
                }}
            >
                <Container>
                    <Grid
                        container
                        item
                        xs={12}
                        lg={7}
                        justifyContent="center"
                        flexDirection="column"
                    >
                        <MKTypography
                            variant="h1"
                            color="white"
                            sx={({ breakpoints, typography: { size } }) => ({
                                [breakpoints.down("md")]: {
                                    fontSize: size["3xl"],
                                },
                            })}
                        >
                            About Erialos - The Silver Fox
                        </MKTypography>
                        <MKTypography
                            variant="body1"
                            color="white"
                            opacity={0.8}
                            mb={2}
                            mr={{ xs: 0, sm: 6 }}
                            pr={{ xs: 0, sm: 6 }}
                        ></MKTypography>
                        <MKTypography variant="h5" color="white" mt={2} mb={1}>
                            Connect with us on
                        </MKTypography>
                        <MKBox display="flex" alignItems="center">
                            <MKTypography
                                component="a"
                                variant="body1"
                                color="white"
                                href={LINKS.twitter}
                                target="_blank"
                                mr={3}
                            >
                                <i className="fab fa-twitter" />
                            </MKTypography>
                            <MKTypography
                                component="a"
                                variant="body1"
                                color="white"
                                href={LINKS.discord}
                                mr={3}
                            >
                                <i className="fab fa-discord" />
                            </MKTypography>
                            <MKTypography
                                component="a"
                                variant="body1"
                                color="white"
                                href={LINKS.github}
                                target="_blank"
                                mr={0}
                            >
                                <i className="fab fa-github" />
                            </MKTypography>
                        </MKBox>
                    </Grid>
                </Container>
            </MKBox>
            ;
        </>
    );
}

export default NavbarHeader;
